if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {   
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
            this.productElement.classList.forEach((classApplied) => {
              if (classApplied.startsWith('color-') || classApplied === 'gradient')
                this.modalContent.classList.add(classApplied);
            });
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
            this.updateSubcription(opener)
            super.show(opener);
            this.enableContentScroll();
            yotpoWidgetsContainer.initWidgets();
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });

        this.injectScrollMore();
      }

      enableContentScroll() {
        const scrollContainer = this.querySelector('.page-width');
        if (!scrollContainer) return;

        scrollContainer.setAttribute('tabindex', '0');
        scrollContainer.focus({ preventScroll: true });

        const modalWrapper = this.querySelector('.quick-add-modal__content');
        if (!modalWrapper) return;

        modalWrapper.addEventListener(
          'wheel',
          (event) => {
            if (scrollContainer.scrollHeight > scrollContainer.clientHeight) {
              event.stopPropagation();
              scrollContainer.scrollTop += event.deltaY;
            }
          },
          { passive: false }
        );
      }

      injectScrollMore() {
        const scrollContainer = this.querySelector('.page-width');
        if (!scrollContainer || scrollContainer.querySelector('#scroll-fade-overlay')) return;

        const fade = document.createElement('div');
        fade.id = 'scroll-fade-overlay';

        const btn = document.createElement('button');
        btn.className = 'scroll-more-btn';
        btn.setAttribute('aria-label', 'Scroll down for more');
        btn.innerHTML = `
          <span>More</span>
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 5.5L7 9.5L11 5.5" stroke="#555555" stroke-width="1.6"
                  stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        `;

        btn.addEventListener('click', () => {
          scrollContainer.scrollBy({ top: 260, behavior: 'smooth' });
        });

        fade.appendChild(btn);
        scrollContainer.appendChild(fade);

        const updateVisibility = () => {
          const atBottom =
            scrollContainer.scrollTop + scrollContainer.clientHeight >= scrollContainer.scrollHeight - 20;
          fade.style.opacity = atBottom ? '0' : '1';
          fade.style.pointerEvents = atBottom ? 'none' : '';
        };

        scrollContainer.addEventListener('scroll', updateVisibility);
        updateVisibility();
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-selects');
        if (!variantPicker) return;

        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, product-info').forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

       updateSubcription(opener) {
        try {
          const subscription = opener?.getAttribute('data-product-subscription');

          if(!subscription) return;
        
          const $checkbox = jQuery(".block__product-recharge-widget .subscribe_product-multiple");
          const $subscribeBlock = $checkbox.closest(".block_product-grid_subscribe");
          const $productForm = $checkbox.closest("form");
          const $dropdown = $subscribeBlock.find(".selling_plan_dropdown");
        
          if ($checkbox.length && $dropdown.length) {
            // Check the checkbox and trigger click
            $checkbox.prop("checked", true).trigger("click");
        
            // Set selected option if subscription value is available
            if (subscription) {
              $dropdown.val(subscription).trigger("change");
            }
        
            // Get selected value and corresponding price
            const productItemSellingPlanID = $dropdown.find(":selected").val();
            const productItemSellingPlanPrice = $checkbox.next().find(".block_product-grid_subscribe-price").data("price");
        
            // Update form fields
            $productForm.find("input[name='selling_plan']").val(productItemSellingPlanID);
            $productForm.find(".product-form__submit .block__product-price").text(productItemSellingPlanPrice);
          } else {
            console.warn("Subscription elements not found — skipping subscription logic.");
          }
        } catch (error) {
          console.error("An error occurred while applying the subscription logic:", error);
        }
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
